import { render, staticRenderFns } from "./projectTags.vue?vue&type=template&id=0e12ba60&"
import script from "./projectTags.vue?vue&type=script&lang=js&"
export * from "./projectTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports